<dx-tag-box
  class="report-entity-filter"
  groupTemplate="filterGroup"
  [dataSource]="dataSource"
  [value]="value"
  [grouped]="true"
  [displayExpr]="'label'"
  [valueExpr]="'value'"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [height]="height"
  [searchEnabled]="true"
  [searchExpr]="['label', 'searchText']"
  [searchMode]="'contains'"
  [searchTimeout]="500"
  [showClearButton]="true"
  [showDropDownButton]="true"
  [showSelectionControls]="true"
  [selectAllMode]="'allPages'"
  [maxDisplayedTags]="maxDisplayedTags"
  [multiline]="false"
  (onValueChanged)="onValueChanged($event)"
  (onClosed)="onClosed($event)"
>
  <div *dxTemplate="let group of 'filterGroup'" class="report-entity-filter__group">
    <dx-check-box
      [value]="getGroupSelectionState(group.key)"
      [enableThreeStateBehavior]="true"
      [text]="group.key"
      (onValueChanged)="onGroupSelectionChanged(group.key, $event)"
    ></dx-check-box>
  </div>
</dx-tag-box>
